module.exports = __webpack_public_path__ + "img/goods2_3.2f5d14c4.jpg";